import {
  Box,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export default function Legalcomponet({ onLegalChange, onButtonClick }) {
  const [value, setValue] = useState({
    agreement: false,
    payment: false,
  });

  // Handler to change the checkbox state
  const valueChange = (e) => {
    const { name, checked } = e.target;
    const newValue = { ...value, [name]: checked };
    setValue(newValue);

    // Notify parent about the changes
    onLegalChange(newValue);
  };

  return (
    <Box sx={{ mt: 2, ml: 1 }}>
      <Box>
        <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
          Legal
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
          1. Acknowledgment of Forwarder Partnership Agreement
        </Typography>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 400, padding: "5px 3px" }}
        >
          By proceeding, you acknowledge that you have received, thoroughly
          reviewed, and fully understand the Forwarder United Parcel Express
          Inc. DBA POSTPAL Forwarder Partnership Agreement. This agreement
          governs your relationship with POSTPAL, including, but not limited to,
          the terms of service, liability, revenue share, and intellectual
          property protections. You agree to be bound by the terms outlined in
          this agreement and adhere to all responsibilities, rights, and
          obligations set forth.
        </Typography>
      </Box>
      <Box mt={1}>
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          2. Acknowledgment of Payment Processing Platforms' Terms & Privacy
          Policy
        </Typography>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 400, padding: "5px 3px" }}
        >
          As part of the payment integration process, you will connect your
          account with one or more third-party payment processing platforms,
          including, but not limited to, Stripe, PayPal, Paystack, PhonePe,
          M-PESA, or other providers supported by POSTPAL. By continuing, you
          acknowledge that you have reviewed and accepted the Privacy Policy and
          Terms & Conditions of these platforms. These agreements govern how
          payments are processed and how personal and financial data are handled
          by these platforms.
        </Typography>
      </Box>
      <Box mt={1} sx={{ padding: "4px 5px" }}>
        <FormControlLabel
          control={
            <Checkbox
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleOutlineIcon />}
              onChange={valueChange}
              name="agreement"
              checked={value.agreement}
            />
          }
          label={
            <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
              I acknowledge that I have received and understand the Forwarder
              United Parcel Express Inc. DBA POSTPAL Forwarder Partnership
              Agreement, and I agree to be bound by its terms.
            </Typography>
          }
        />
        <FormControlLabel
          // sx={{ mt: 1 }}
          control={
            <Checkbox
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleOutlineIcon />}
              onChange={valueChange}
              name="payment"
              checked={value.payment}
            />
          }
          label={
            <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
              I acknowledge that I have read, understood, and accepted the
              Privacy Policy and Terms & Conditions of the selected payment
              processing platforms.
            </Typography>
          }
        />
      </Box>

      <Box mt={1}>
        <Box>
          <Button
            variant="contained"
            onClick={() => {
              // Pass button click to parent if needed
              onButtonClick(value);
            }}
          >
            Continue with connecting payment
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
